import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { DuplicateRequestCheckDto, GeneralRequestDto, GeneralRequestSaveDto } from '../models/general-request-models';

@Injectable({
  providedIn: 'root'
})
export class GeneralRequestService {
  baseUrl = 'GeneralRequest';

  constructor(private httpCommonService: HttpCommonService) {
  }

  getById(id: string): Observable<ApiResponse<GeneralRequestDto>> {
    return this.httpCommonService.get<ApiResponse<GeneralRequestDto>>({
      url: `${this.baseUrl}/Get/${id}`
    });
  }

  save(model: GeneralRequestSaveDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>({
      url: this.baseUrl + '/Save',
      body: model
    });
  }

  getPartnerActivity(partnerId: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.get<ApiResponse<string>>({
      url: `${this.baseUrl}/GetPartnerActivity/${partnerId}`
    });
  }

  getByApprovalRequestId(approvalRequestId: string): Observable<ApiResponse<GeneralRequestDto>> {
    return this.httpCommonService.get<ApiResponse<GeneralRequestDto>>({
      url: `${this.baseUrl}/GetByApprovalRequestId/${approvalRequestId}`
    });
  }

  generateGeneralRequestSignatureForm(baseRequestId: string): Observable<Blob> {
    return this.httpCommonService.get<Blob>({
      url: `${this.baseUrl}/GenerateGeneralRequestSignatureForm/${baseRequestId}`,
      responseType: 'blob'
    });
  }

  checkForDuplicateRequests(
    requestedPartnerId: string,
    generalRequestTypeId: number,
    excludeRequestId?: string
  ): Observable<ApiResponse<DuplicateRequestCheckDto>> {
    let params = `?requestedPartnerId=${requestedPartnerId}&generalRequestTypeId=${generalRequestTypeId}`;
    if (excludeRequestId) {
      params += `&excludeRequestId=${excludeRequestId}`;
    }
    return this.httpCommonService.get<ApiResponse<DuplicateRequestCheckDto>>({
      url: `${this.baseUrl}/CheckForDuplicateRequests${params}`
    });
  }
}
